import { isEventAttributeType } from '@src/emp-3.0/components/custom-dimension/utils/checks';
import {
  EAttributeType,
  ICreateCustomDimensionPayload,
  IUpdateCustomDimensionPayload,
} from '@src/emp-3.0/types';

export const validateCustomDimensionPayload = (
  data: ICreateCustomDimensionPayload | IUpdateCustomDimensionPayload = {
    attribute_name: '',
    display_name: '',
    category: 'custom',
    mapped_event_names: [],
    attribute_type: EAttributeType.Global,
  },
  bypassFields: string[] = [],
) => {
  const isEventAttribute = isEventAttributeType(data.attribute_type);
  const filteredArray: string[] = data.mapped_event_names.filter((str: string) => str !== '');

  if ((!bypassFields.includes('display_name') && !data.display_name) || !data.attribute_name) {
    return {
      failed: true,
      message: 'Dimension Name and Tag Key are required!',
      field: 'attribute_name',
    };
  } else if (
    !bypassFields.includes('mapped_event_names') &&
    isEventAttribute &&
    filteredArray.length === 0
  ) {
    return {
      failed: true,
      message: 'At least one Mapped Event is required!',
      field: 'mapped_event_names',
    };
  }

  return {
    failed: false,
    message: '',
    field: '',
  };
};
